<template>
  <div id="app">
    <el-container>
      <el-header height="48px" style="position: fixed;z-index: 999;">
        <div style="width: 100%;display: flex;justify-content: space-between;">
          <div class="logo">
            <router-link to="/">
              <img src="./assets/img/toplogo3.png" alt />
            </router-link>
          </div>
          <!-- 新增移动端汉堡菜单按钮 -->
          <div @click="toggleMobileMenu" class="mobile-menu-btn" v-if="isMobile">
            <i :class="!isMobileMenuOpen ? 'el-icon-s-fold' : 'el-icon-s-unfold'"></i>
          </div>
          <!-- 原有桌面端菜单 -->
          <el-menu v-if="!isMobile"
                   :default-active="defaultActive"
                   class="el-menu-demo"
                   mode="horizontal"
              @select="handleSelect"
              background-color="#1E1E1E"
              :router="router"
              active-text-color="#fff"
          >
            <el-menu-item index="/" class="nav">首页</el-menu-item>

            <el-submenu index="/product" @click.native.prevent="handleSelectMenu('/product')" :class="isActive?'is-active':''">
              <template slot="title" >产品中心</template>
              <div class="product-box">
                <div class="product" v-for="item in productList" :key="item.id">
                  <p>{{item.name}}</p>
                  <el-menu-item index="/detail" @click="handleSelectMenu('/detail',item2)" v-for="item2 in item.children" :key="item2.id">{{item2.name}}</el-menu-item>
                </div>
              </div>
            </el-submenu>
            <el-menu-item index="/cloud" class="nav">云平台</el-menu-item>
            <el-submenu index="/service" class="nav">
              <template slot="title">技术服务</template>
              <div class="service">
                <el-menu-item index="/warranty">保修服务</el-menu-item>
                <el-menu-item index="/authentication">检测认证</el-menu-item>
                <el-menu-item index="/customized">需求定制</el-menu-item>
              </div>
            </el-submenu>
            <!--          <el-submenu index="/scheme">-->
            <!--            <template slot="title">解决方案</template>-->
            <!--            <div class="service">-->
            <!--              <el-menu-item index="/industry">智慧工业</el-menu-item>-->
            <!--              <el-menu-item index="/energy">智慧能源</el-menu-item>-->
            <!--              <el-menu-item index="/power">智慧电力</el-menu-item>-->
            <!--              <el-menu-item index="/city">智慧城市</el-menu-item>-->
            <!--              <el-menu-item index="/building">智慧建筑</el-menu-item>-->
            <!--            </div>-->
            <!--          </el-submenu>-->
            <el-submenu index="/download" class="nav">
              <template slot="title">在线商城</template>
              <div class="shopping-box">
                <div>
                  <img :src="'/boot'+info.qrCodeTm" alt="">
                  <p>天猫旗舰店</p>
                </div>
<!--                <div class="shu"></div>-->
<!--                <div>-->
<!--                  <img :src="'/boot'+info.qrCodeJd" alt="">-->
<!--                  <p>京东旗舰店</p>-->
<!--                </div>-->
              </div>
            </el-submenu>
            <el-submenu index="/about" class="nav" :class="isAbout?'is-active':''">
              <template slot="title">关于我们</template>
              <div class="service">
                <el-menu-item index="/about#synopsis">博为简介</el-menu-item>
                <el-menu-item index="/about#culture">企业文化</el-menu-item>
                <el-menu-item index="/about#organization">组织架构</el-menu-item>
                <el-menu-item index="/about#honor">资质荣誉</el-menu-item>
                <el-menu-item index="/about#contact">联系我们</el-menu-item>
              </div>
            </el-submenu>
          </el-menu>
          <!-- 新增移动端折叠菜单 -->
          <div v-if="isMobileMenuOpen" class="mobile-menu-overlay">
            <div class="mobile-menu">
              <!-- 新增关闭按钮 -->
              <div class="close-btn" @click="toggleMobileMenu">
                <i class="el-icon-close"></i>
              </div>
              <el-menu mode="vertical" @select="handleMobileSelect">
                <el-menu-item index="/">首页</el-menu-item>
                <!-- 新增云平台菜单项 -->
                <el-menu-item index="/product">产品中心</el-menu-item>
                <el-menu-item index="/cloud">云平台</el-menu-item>
                <!-- 新增技术服务子菜单 -->
                <el-submenu index="service">
                  <template slot="title">技术服务</template>
                  <el-menu-item index="/warranty">保修服务</el-menu-item>
                  <el-menu-item index="/authentication">检测认证</el-menu-item>
                  <el-menu-item index="/customized">需求定制</el-menu-item>
                </el-submenu>
                <!-- 新增解决方案子菜单 -->
<!--                <el-submenu index="scheme">
                  <template slot="title">解决方案</template>
                  <el-menu-item index="/industry">智慧工业</el-menu-item>
                  <el-menu-item index="/energy">智慧能源</el-menu-item>
                  <el-menu-item index="/power">智慧电力</el-menu-item>
                  <el-menu-item index="/city">智慧城市</el-menu-item>
                  <el-menu-item index="/building">智慧建筑</el-menu-item>
                </el-submenu>-->
                <!-- 新增在线商城菜单 -->
                <el-submenu index="download">
                  <template slot="title">在线商城</template>
                  <el-menu-item index="1">天猫旗舰店</el-menu-item>
<!--                  <el-menu-item index="/download/jd">京东旗舰店</el-menu-item>-->
                </el-submenu>
                <!-- 新增关于我们子菜单 -->
                <el-submenu index="about">
                  <template slot="title">关于我们</template>
                  <el-menu-item index="/about#synopsis">博为简介</el-menu-item>
                  <el-menu-item index="/about#culture">企业文化</el-menu-item>
                  <el-menu-item index="/about#organization">组织架构</el-menu-item>
                  <el-menu-item index="/about#honor">资质荣誉</el-menu-item>
                  <el-menu-item index="/about#contact">联系我们</el-menu-item>
                </el-submenu>
              </el-menu>
            </div>
          </div>
        </div>
      </el-header>
      <el-main style="margin-top: 48px;overflow: visible;">
        <div class="dialog-box-left-false" @click="isLeft = !isLeft" v-if="!isLeft">
          <img src="@/assets/img/phon-icon2.png" alt="">
        </div>
        <div class="dialog-box-left" v-if="isLeft">
          <img class="x-class"  @click="isLeft = !isLeft" src="@/assets/img/x-icon.png" alt="">
          <h1>微信扫码咨询</h1>
          <div class="img-box">
            <img :src="'/boot'+info.qrCodeKefu" alt="">
          </div>
          <div class="dialog-bottom">
            <img src="@/assets/img/phone-icon.png" alt="">
            <div>
              <p>咨询电话</p>
              <p>{{info.consultationTelephone}}</p>
            </div>
          </div>
        </div>
        <div class="dialog-box-right">
          <div class="title-box">
            <span>请您留言</span>
            <div class="suoxiao" @click="isRight=!isRight">
              <div></div>
            </div>
          </div>
          <div class="dialog-form" v-if="isRight">
            <el-form ref="form" :model="form" :rules="rules">
              <el-form-item label="" prop="guestbook">
                <el-input v-model="form.guestbook" type="textarea" maxlength="200" :rows="2" placeholder="请输入详细留言内容，我们会尽快与您联系~" />
              </el-form-item>
              <el-form-item label="" prop="contact">
                <el-input v-model="form.contact" placeholder="请输入您的姓名" />
              </el-form-item>
              <el-form-item label="" prop="phone">
                <el-input v-model="form.phone" placeholder="请输入您的电话" />
              </el-form-item>
              <el-form-item label="" prop="email">
                <el-input v-model="form.email" placeholder="请输入您的邮箱" />
              </el-form-item>

              <el-button class="btn-class" @click="submitForm"  style="float: right;" type="primary">提交</el-button>
            </el-form>
          </div>
        </div>

        <router-view />
      </el-main>
      <div class="footer" v-show="isShow">
<!--        <div class="footer">-->
          <div class="footer-content">
            <div class="content-left">
              <div class="content-left-top">
                <div>
                  <img :src="'/boot'+info.qrCodeWechat" alt="">
                  <p>微信公众号</p>
                </div>
                <div>
                  <img :src="'/boot'+info.qrCodeTm" alt="">
                  <p>天猫旗舰店</p>
                </div>
                <div>
                  <img :src="'/boot'+info.qrCodeJd" alt="">
                  <p>博为智能抖音</p>
                </div>
              </div>
              <div class="content-left-bottom">
                <p>联系方式：<a :href="`tel:${info.fixed}`">{{info.fixed}}</a>丨 <a :href="`tel:${info.phoneNumber}`">{{info.phoneNumber}}</a></p>
                <p>电子邮箱：<a :href="`mailto:${info.email}`">{{info.email}}</a></p>
                <p>公司地址：{{info.companyAddress}}</p>
                <p>友情链接：<a href="http://www.hnbwzn.com/" target="_blank">河南博为智能科技有限公司</a> &nbsp;&nbsp; <a href="http://www.hnxintu.com/" target="_blank">SMT贴片加工</a></p>
              </div>
            </div>
            <ul class="content-nav">
              <li>
                <p @click="$router.push({ path: '/product' })">产品中心</p>
                <span v-for="item in deviceTypeList" @click="handleSelectMenu('/product',item)" :key="item.id">{{item.name}}</span>
              </li>
<!--              <li>-->
<!--                <p>解决方案</p>-->
<!--                <span @click="handleSelectMenu('/industry')">智慧工业</span>-->
<!--                <span @click="handleSelectMenu('/energy')">智慧能源</span>-->
<!--                <span @click="handleSelectMenu('/power')">智慧电力</span>-->
<!--                <span @click="handleSelectMenu('/city')">智慧城市</span>-->
<!--                <span @click="handleSelectMenu('/building')">智慧建筑</span>-->
<!--              </li>-->
              <li>
                <p @click="handleSelectMenu('/about' )">关于我们</p>
                <span @click="handleSelectMenu('/about#synopsis' )">博为简介</span>
                <span @click="handleSelectMenu('/about#culture' )">企业文化</span>
                <span @click="handleSelectMenu('/about#organization' )">组织架构</span>
                <span @click="handleSelectMenu('/about#honor' )">资质荣誉</span>
                <span @click="handleSelectMenu('/about#contact' )">联系我们</span>
              </li>
            </ul>
          </div>
          <div class="copyright">
            <span>Copyright© 2025 河南博为智能科技有限公司 版权所有  <a href="https://beian.miit.gov.cn/" target="_blank">豫ICP备2020029776号-2</a></span>
          </div>
<!--        </div>-->
      </div>
    </el-container>
  </div>
</template>

<script>
import {configList, productsListTree,guestbook} from "@/utils/http";
export default {
  data() {
    return {
      router: true,
      defaultActive: "/",
      isShow: false,
      isLeft:true,
      isRight:true,
      width:window.innerWidth,
      deviceTypeList: [
        {name:'边缘计算',id:'1'},
        {name:'串口服务器',id:'2'},
        {name:'蓄电池监测',id:'3'},
        {name:'温湿度传感器',id:'4'},
        {name:'远程IO',id:'5'},
      ],
      productList:[],
      info:{},
      form:{
        contact:'',
        phone:'',
        email:'',
        guestbook:'',
      },
      rules: {
        guestbook:[
          { validator: this.validateNoSpace, trigger: 'submit' },
        ],
        contact: [
          { required: true, message: "联系人不能为空", trigger: "submit" },
          { min: 1, max:10,message: '请输入10个以内字符', trigger: 'submit' },
          { validator: this.validateNoSpace, trigger: 'submit' }
        ],
        phone: [
          { required: true, message: "联系电话不能为空", trigger: "submit" },
          { validator: this.validateNoSpace, trigger: 'submit' },
          { pattern: /^(0\d{2,3}-)?\d{7,8}(-\d{1,4})?$|^1[3-9]\d{9}$/, message: '请输入正确的电话，电话请加上区号与-' }
          // { pattern:/^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/, message: '请输入正确的电话，电话请加上区号与-' }
        ],
        email: [
          { validator: this.validateNoSpace, trigger: 'submit' },
          { max: 50, message: '请输入不超过50个字符', trigger: 'submit' },
          // { required: true, message: "联系邮箱不能为空", trigger: "change" },
          // { pattern: /^[a-zA-Z0-9_-]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/, message: '请输入正确的邮箱地址' }
        ],
      },
      isActive:false,
      isAbout:false,
      isMobile: window.innerWidth < 768,
      isMobileMenuOpen: false
    };
  },
  created() {
    if(localStorage.getItem('defaultActive') && localStorage.getItem('defaultActive') == '/product') {
      this.defaultActive = localStorage.getItem('defaultActive');
      this.isActive = true
      this.isShow = true
    }
  },
  mounted() {
    this.getConfigList()
    this.getProductsListTree()
    window.addEventListener('resize', this.handleResize);
  },
  watch: {
    $route(to, from) {
      if(to.path == '/' || to.path == '/cloud') {
        this.isShow = false
      } else {
        this.isShow = true
      }
      this.defaultActive = to.path
      if(to.path == '/product') {
        this.defaultActive = '/product'
        localStorage.setItem('defaultActive', '/product');
        this.isActive = true
      } else {
        localStorage.removeItem('defaultActive')
        this.isActive = false
      }

      if(to.path == '/about') {
        this.isAbout = true
      } else {
        this.isAbout = false
      }
    },
    immediate: true,
    deep: true
  },
  methods: {
    handleResize() {
      this.isMobile = window.innerWidth < 768;
      if(this.isMobile) this.isMobileMenuOpen = false;
    },
    toggleMobileMenu() {
      this.isMobileMenuOpen = !this.isMobileMenuOpen;
    },
    handleMobileSelect(index) {
      if(index === '1') {
        this.openTaobaoStore()
        this.isMobileMenuOpen = false;
        return
      }
      this.$router.push(index);
      this.isMobileMenuOpen = false;
    },
    validateNoSpace(rule, value, callback) {
      if (/\s/.test(value)) {
        callback(new Error('此字段不能包含空格'));
      } else {
        callback();
      }
    },
    handleSelect(key) {
      this.defaultActive = key
    },
    handleSelectMenu(path, item){
      if(item){
        let {id, buyLink} = item
        this.$router.push({path:path,query:{id, buyLink}})
      }else {
        this.defaultActive = path
        this.$router.push({path:path})
      }
    },
    async getConfigList(){
      const res = await configList();
      this.info = res.rows[0]
    },
    async getProductsListTree(){
      const res = await productsListTree();
      this.productList = res.data
      this.deviceTypeList = res.data.map(item => {
        return {
          name: item.name,
          id: item.id
        }
      })
    },
    /**  重置  */
    reset(){
      this.form = {
        contact:'',
        phone:'',
        email:'',
        guestbook:'',
      }
    },
    /** 提交按钮 */
    submitForm() {
      this.$refs["form"].validate(valid => {
        if (valid) {
          guestbook(this.form).then(response => {
            if(response.code === 200){
              this.$message.success("提交成功！感谢您的信任，我们将尽快与您联系，为您服务。");
              this.reset()
            }else {
              this.$message.error(response.msg)
            }
          });
        }
      });
    },
    openTaobaoStore() {
      const url = 'https://shop387707904.m.taobao.com/';
      window.open(url, '_blank');
    }
  }
};
</script>

<style lang="scss">
* {
  padding: 0;
  margin: 0;
}
html,
body {
  height: 100%;
}

#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}
.el-menu--horizontal>.el-submenu.is-active .el-submenu__title{
  background-color: #1277E4 !important;
  color: #ffffff!important;
}
.el-header {
  display: flex;
  justify-content: space-around;
  align-content: center;
  width: 100%;
  background: #1E1E1E;
  .logo {
    width: 226px;
    padding: 10px 0;
    img {
      width: 100%;
      line-height: 48px;
    }
  }

  .el-menu--horizontal>.el-menu-item{
    height: 48px;
    line-height: 48px;
    border-bottom:0;
  }
  .el-menu--horizontal>.el-menu-item.is-active {
    border-bottom: 0;
    background-color: #1277E4 !important;
  }
  .el-menu--horizontal>.el-submenu .is-active{
    height: 48px;
    line-height: 48px;
    border: none!important;
  }
  .el-menu--horizontal .el-menu-item:not(.is-disabled):focus, .el-menu--horizontal .el-menu-item:not(.is-disabled):hover{
    color: #fff;
  }
  .el-menu--horizontal>.el-submenu .el-submenu__title{
    height: 48px;
    line-height: 48px;
    border: none!important;
  }
  .el-menu--horizontal>.el-submenu .el-submenu__title:hover{
    color: #fff;
  }

}
.el-main {
  padding: 0 !important;
  //.con-top{
  //  &-bgImg{
  //    width: 100%;
  //    img{
  //      width: 100%;
  //      height: 100%;
  //    }
  //  }
  //  &-top{
  //    width: 1200px;
  //    margin: 0 auto;
  //  }
  //  &-box{
  //    width: 100%;
  //    height: 20px;
  //    background: #F7F7F7;
  //  }
  //}
  .dialog-box-left-false{
    width: 38px;
    height: 38px;
    //background: linear-gradient( 185deg, #11B2DE 0%, #135EE6 100%);
    //border-radius: 12px 12px 12px 12px;
    //border: 1px solid rgba(0,0,0,0);
    position: fixed;
    bottom: 228px;
    left: 13px;
    z-index: 999;
    cursor: pointer;
    text-align: center;
    line-height: 45px;
  }
  .dialog-box-left{
    position: fixed;
    bottom: 0;
    width: 184px;
    height: 262px;
    background: #FFFFFF;
    border-radius: 4px;
    z-index: 999;
    left: 32px;
    font-family: Microsoft YaHei, Microsoft YaHei;
    text-align: center;
    .x-class{
      position: absolute;
      right: -10px;
      top: -10px;
      cursor: pointer;
    }
    h1{
      font-weight: 400;
      font-size: 14px;
      color: #666666;
      margin:26px 0 23px 0;
    }
    .img-box{
      width: 112px;
      height: 112px;
      margin: 0 auto 16px auto;
      img{
        width: 100%;
        height: 100%;
      }
    }
    .dialog-bottom{
      display: flex;
      align-items: center;
      text-align: left;
      margin-left: 21px;
      font-weight: 400;
      font-size: 14px;
      color: #333333;
      img{
        width: 15px;
        height: 15px;
        margin-right: 10px;
      }
    }
  }
  .dialog-box-right{
    width: 264px;
    background: #FFFFFF;
    z-index: 999;
    border-radius: 4px;
    position: fixed;
    bottom: 0;
    right: 32px;
    .title-box{
      width: 100%;
      height: 36px;
      background: #3275F6;
      border-radius: 4px 4px 0px 0px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      span{
        margin-left: 16px;
        font-weight: 400;
        font-size: 16px;
        color: #FFFFFF;
      }
      .suoxiao{
        padding: 15px 0;
        margin-right: 15px;
        cursor: pointer;
        div{
          width: 14px;
          height: 2px;
          background: #FFFFFF;
        }
      }

    }

    .dialog-form{
      height: 270px;
      padding:20px 20px 0 20px;
      .el-input__inner{
        height: 32px !important;
      }
      .el-form-item{
        margin-bottom: 10px !important;
      }
      .el-form-item__error{
       padding: 0;
      }
      .btn-class{
        width: 56px;
        height: 32px;
        background: #1262FD;
        border-radius: 2px;
        padding: 0;
      }
    }
  }
}

.footer {
  width: 100%;
  //height: 344px;
  padding-top: 46px;
  overflow: hidden;
  background-color: #1E1E1E;
  &-content {
    width: 1240px;
    height: 230px;
    margin: 0 auto;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .content-left{
      &-top{
        display: flex;
        div{
          text-align: center;
          margin-right: 45px;
          img{
            width: 100px;
            height: 100px;
            padding: 0;
          }
          p{
            margin: 0;
            font-size: 12px;
            color: #FFFFFF;
          }
        }
      }
      &-bottom{
        margin-top: 20px;
        font-size: 13px;
        color: #D4D4D4;
        line-height: 28px;
        margin-bottom: 45px;


        a {
          color: #D4D4D4;
          text-decoration: none;
        }

        a:hover {
          color: #23527c;
          text-decoration: underline;
        }
      }
    }
    .content-nav {
      height: 170px;
      display: flex;
      justify-content: space-around;
      overflow: hidden;
      li {
        display: flex;
        flex-direction: column;
        padding: 0 20px;
        //justify-content: center;
        align-items: flex-start;
        font-family: Microsoft YaHei, Microsoft YaHei;
        p {
          font-size: 15px;
          color: #FFFFFF;
          padding: 10px 0;
        }
        span {
          font-size: 12px;
          color: rgba(255,255,255,0.6);
          font-weight: 300;
          padding: 5px 0;
          cursor: pointer;
        }
      }
    }
    img {
      width: 170px;
      height: 170px;
      padding: 10px;
    }
  }
  .copyright {
    height: 30px;
    background: #0E0E0E;
    text-align: center;
    span, a {
      color: #fff;
      line-height: 30px;
      font-size: 12px;
      text-decoration: none;
    }

    a:hover {
      color: #23527c;
      text-decoration: underline;
    }
  }

}
.el-textarea__inner{
  max-height: 300px!important;
}
.product-box{
  width: 1900px;
  display: flex;
  justify-content: center;
  font-size: 14px;
  padding: 20px 0;
  .product{
    margin: 0 40px;
    line-height: 30px;
    p{
      color: #222222;
    }
    span{
      display: block;
      color: #666666;
      cursor: pointer;
    }
    span:hover{
      text-decoration: underline;
    }

    .el-menu-item{
      text-decoration: underline;
      padding: 0!important;
      color: #666666!important;

    }

  }
}
.shopping-box{
  height: 96px;
  display: flex;
  padding: 0 20px;
  justify-content: center;
  align-items: center;
  text-align: center;
  .shu{
    width: 1px;
    height: 72px;
    background: #E7E7E7;
    margin: 0 20px;
  }
  img{
    width: 56px;
    height: 56px;
  }
  p{
    font-size: 12px;
    color: #222222;
  }
}
.el-menu--popup{
  background: #fff!important;
  min-width: 96px!important;
  text-align: center!important;
}
.el-menu--popup-bottom-start{
  margin: 0!important;
}
.el-menu--horizontal .el-menu .el-menu-item, .el-menu--horizontal .el-menu .el-submenu__title{
  background: #fff!important;
}
.el-menu--horizontal .el-menu .el-menu-item:hover{
  background: #F2F2F2!important;
  color: #1277E4!important;
}
.el-menu--horizontal>.el-submenu .el-submenu__icon-arrow{
  display: none;
}
.el-menu--horizontal>.el-submenu:focus .el-submenu__title, .el-menu--horizontal>.el-submenu:hover .el-submenu__title{
  color: #fff!important;
}

.service .is-active{
  color: #1277E4 !important;
}
.el-breadcrumb__item .el-breadcrumb__inner a{
  color: #898989!important;
  font-weight: normal;
}
.el-breadcrumb__item:last-child .no-redirect{
  color: #222222!important;
  font-weight: bold;
}

// 新增移动端全屏样式
.mobile-menu-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  z-index: 1000;
}

.mobile-menu {
  position: fixed;
  top: 0;
  right: 0;
  width: 80%;
  height: 100%;
  background: white;
  padding-top: 40px;
  transition: all .3s;
  .el-menu-item a {
    color: #303133 !important;
    text-decoration: none !important;
  }
}

.close-btn {
  position: absolute;
  top: 10px;
  right: 20px;
  cursor: pointer;
  font-size: 24px;
}

.dialog-box-left-false, .dialog-box-left, .dialog-box-right {
  display: none;
}
</style>
